module.exports = "/_next/static/images/avatar_Simona-df39bfe6d33bd3978491ff39755c772e.svg";